import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {
  ActionMenuHeader,
  ActionMenuHeaderButton,
  ActionMenuHeaderIcons,
} from '#/components/actionmenu/action-menu-header';
import {
  ActionMenuControlledTabsContent,
  ActionMenuControlledTabsList,
  ActionMenuControlledTabsRoot,
} from '#/components/actionmenu/action-menu-tabs';
import {ActionMenuContentSectionBalance} from '#/components/actionmenu/content/action-menu-content-section-balance';
import {ActionMenuRentClaimTab} from '#/components/actionmenu/sections/rent/action-menu-rent-claim-tab';
import {ActionMenuRentRentTab} from '#/components/actionmenu/sections/rent/action-menu-rent-rent-tab';
import {ActionMenuRentStopRentTab} from '#/components/actionmenu/sections/rent/action-menu-rent-stop-rent-tab';
import {ActionMenuSection} from '#/components/actionmenu/types';
import {transactionActivityTileProps} from '#/components/transaction/transaction-type-constants';
import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {WalletContext} from '#/contexts/wallet-provider';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {RentTab} from '#/navigation/tabs';
import {DefaultChildren} from '#/utils/utils';
import {ArrowDownTrayIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {TransactionType} from 'shareland-common';
import {useQueryParams} from 'use-query-params';

const RentIcon = transactionActivityTileProps[TransactionType.MintLiquidityToken].IconComponent;
const StopRentIcon = transactionActivityTileProps[TransactionType.BurnLiquidityToken].IconComponent;
const ClaimIcon = ArrowDownTrayIcon;

export const ActionMenuRent: FunctionComponent<DefaultChildren> = () => {
  const {
    accountResult: {isConnected},
  } = useContext(WalletContext);

  const {t} = useTranslation('translation');

  return (
    <ActionMenuControlledTabsRoot
      queryParamTabKey='rentTabId'
      tabKeys={RentTab}
      data={[
        {
          value: RentTab.RENT,
          name: t('pages.actionMenu.rent.sections.rent.title'),
          IconComponent: RentIcon,
          ContentComponent: ActionMenuRentRentTab,
        },
        {
          value: RentTab.STOP_RENT,
          name: t('pages.actionMenu.rent.sections.stopRent.title'),
          IconComponent: StopRentIcon,
          ContentComponent: ActionMenuRentStopRentTab,
        },
        {
          value: RentTab.CLAIM,
          name: t('pages.actionMenu.rent.sections.claim.title'),
          IconComponent: ClaimIcon,
          ContentComponent: ActionMenuRentClaimTab,
        },
      ]}
    >
      <ActionMenuRentHeader />
      <ActionMenuControlledTabsList />
      {isConnected && <ActionMenuContentSectionBalance />}
      <ActionMenuControlledTabsContent />
    </ActionMenuControlledTabsRoot>
  );
};

const ActionMenuRentHeader: FunctionComponent = () => {
  const {land, landMarketInfo} = useContext(ActionMenuContext);
  const [{actionSource}] = useQueryParams<SLQueryParamConfig>();

  // External hooks
  const {
    actionMenu: {close, openInformation},
  } = useQueryNavigationActions();

  return (
    <>
      <ActionMenuHeader land={land} landMarketInfo={landMarketInfo}>
        {actionSource === ActionMenuSection.INFORMATION ? (
          <ActionMenuHeaderButton onClick={() => openInformation(land)}>
            <ActionMenuHeaderIcons.Back />
          </ActionMenuHeaderButton>
        ) : (
          <>
            <ActionMenuHeaderButton onClick={close}>
              <ActionMenuHeaderIcons.Close />
            </ActionMenuHeaderButton>
          </>
        )}
      </ActionMenuHeader>
    </>
  );
};
